import api from './api';
import type { User } from '../types/auth';

export interface UsersResponse {
  success: boolean;
  data: {
    users: User[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalRecords: number;
      recordsPerPage: number;
    };
  };
}

export interface CreateUserRequest {
  username: string;
  password: string;
  role: string;
  department: string;
}

export interface UpdateUserRequest {
  username?: string;
  role?: string;
  department?: string;
  is_active?: boolean;
}

export const usersService = {
  // Get all users (filtered by department based on requesting user's role)
  getUsers: async (params?: {
    role?: string;
    department?: string;
    is_active?: boolean;
    page?: number;
    limit?: number;
  }): Promise<UsersResponse> => {
    const queryParams = new URLSearchParams();
    
    if (params?.role) queryParams.append('role', params.role);
    if (params?.department) queryParams.append('department', params.department);
    if (params?.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());

    const response = await api.get(`/users?${queryParams.toString()}`);
    return response.data;
  },

  // Create a new user
  createUser: async (userData: CreateUserRequest) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Update a user
  updateUser: async (userId: number, userData: UpdateUserRequest) => {
    const response = await api.patch(`/users/${userId}`, userData);
    return response.data;
  },

  // Toggle user active status
  toggleUserStatus: async (userId: number) => {
    const response = await api.patch(`/users/${userId}/toggle-status`);
    return response.data;
  },

  // Reset user password
  resetUserPassword: async (userId: number, newPassword: string) => {
    const response = await api.patch(`/users/${userId}/reset-password`, {
      new_password: newPassword
    });
    return response.data;
  },

  // Delete a user
  deleteUser: async (userId: number) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  }
};
